module.exports = __webpack_public_path__ + "static/media/65_metal_surface_seamless.a46e138f.jpg";